<div class="alert" 
  *ngIf="display"
  [ngClass]="{error: type === 'error'}" >
  <div class="alert-close" (click)="close()">
    <i class="ae ae-times"></i>
  </div>
  <div class="alert-title" *ngIf="title">
    {{ title | translate }}
  </div>

  <div class="alert-content">
    <ng-content></ng-content>
  </div>
</div>